// components/redirects/SubCategoryRedirect.jsx
import { Navigate, useParams } from "react-router-dom";

function SubCategoryRedirect() {
  const { main_category_url, category_url, subcategory_url } = useParams();

  return (
    <Navigate
      to={`/${main_category_url}/${category_url}/${subcategory_url}`}
      replace
    />
  );
}

export default SubCategoryRedirect;
